import logoSrc from '~/assets/logo_notext.png'
import { BRANDING } from '~/config/branding'
import { LOGO_URL } from '~/config/tenant'

interface Props {
  height: number
}

export function Logo({ height }: Props) {
  return (
    <img src={LOGO_URL ?? logoSrc} alt={BRANDING.productTitle} style={{ height, width: 'auto' }} />
  )
}
